// Keeps Swatch King collection swatches under the buy button on product cards.
//
// The app is set to "After price", which anchors on the .product-price-rating-row
// that the Lipscore custom-liquid block builds on DOMContentLoaded. Cards in the
// first render get their swatches before that row exists, so the app falls back to
// appending them to the product card, under the button. Cards added later
// (infinite scroll, filtering) already have the row, so their swatches land above
// the button instead. Move those to where the first render puts them.

const MISPLACED_SWATCHES_SELECTOR = 'product-card .product-card__content variant-swatch-king';

const moveSwatchesUnderButton = (root = document) => {
  for (const swatches of root.querySelectorAll(MISPLACED_SWATCHES_SELECTOR)) {
    swatches.closest('product-card')?.append(swatches);
  }
};

const start = () => {
  moveSwatchesUnderButton();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('variant-swatch-king') || node.querySelector('variant-swatch-king')) {
          moveSwatchesUnderButton();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
